module.exports = {
    mode:'release',
    debug:{
        image_path:'http://localhost:3000',
        web_path:'http://localhost:9529',
    },
    release:{
        image_path:'https://www.ixren.com:3000',
        web_path:'https://www.ixren.com',
    }

}